/* eslint-disable max-nested-callbacks */
 
import {HTTP_STATUS_NOCONTENT} from '../../smartpak/httpstatus';
import {onDOMContentLoaded} from '../../dom/events';
import modal from '../../smartpak/modal';
import $ from 'jquery';

onDOMContentLoaded(() => {
    var $catalogForm = $('#catalogOptOutForm'),
        catalogSuccessMessage =
            'Your request has been submitted! You might receive 1-2 more catalogs before the removal process is complete. Thank you for your patience.',
        catalogErrorMessage = 'Error submitting form data. Please try again.';

    $catalogForm.on('submit', function (e) {
        if ($catalogForm.valid()) {
            e.preventDefault();

            $.ajax({
                url: '/api/customercontact/catalogoptout',
                type: 'POST',
                data: $catalogForm.serialize()
            }).done(function (data) {
                if (data.Status === HTTP_STATUS_NOCONTENT) {
                    showCatalogSubmitResponse(catalogSuccessMessage, function () {
                        window.location.href = '/';
                    });
                } else {
                    showCatalogSubmitResponse(catalogErrorMessage);
                }
            });
        }
    });
});

function showCatalogSubmitResponse(message, callback) {
    modal($('<div><p>' + message + '</p></div>').get(0), {
        title: 'Catalog Mailing Opt-out',
        width: 600,
        removeContents: true,
        close: function () {
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        buttons: [
            {
                text: 'Ok',
                class: 'primary',
                click: function (modal) {
                    modal.close();
                }
            }
        ]
    });
}
